import React, { memo } from 'react';
import UserWeightSetting from './UserWeightSetting';
import ComparisonSetting from './ComparisonSetting';
import RatingSetting from './RatingSetting';
import GoalWeightSettings from './Components/GoalWeightSettings';

const GeneralSettings = () => {
  return (
    <>
      <div className="background-white p-20 ">
        <GoalWeightSettings />
      </div>
      <div className="background-white p-20 mt-30 general-setting">
        <UserWeightSetting />
      </div>
      <div className="background-white p-20 mt-30 general-setting">
        <ComparisonSetting />
      </div>
      <div className="background-white p-20 mt-30 general-setting">
        <RatingSetting />
      </div>
    </>
  );
};
export default memo(GeneralSettings);

